import { differenceInDays } from "date-fns";

/**
 * @module order
 * @category helpers
 */

import { isAfter } from "date-fns";

/**
 * Check whether order ID is valid or not
 * @param {string} orderId Order ID to check
 * @returns {boolean} true or false
 */
export const isValidOrderId = (orderId: any): boolean => {
  return /^[0-9]{6,8}$/.test(orderId);
};

export const orderHasBeenDelivered = (order: {
  deliveryDate: string;
  realtimeEstimate: { confirmedDeliveryTime: string | null };
}): boolean => {
  if (!order || !order.deliveryDate || !order.realtimeEstimate) {
    return false;
  }

  const confirmedDeliveryTime = order.realtimeEstimate.confirmedDeliveryTime;
  const isMinimumOneDayAfterDelivery = isAfter(
    new Date().setHours(0, 0, 0, 0),
    new Date(order.deliveryDate).setHours(0, 0, 0, 0),
  );

  return confirmedDeliveryTime !== null || isMinimumOneDayAfterDelivery;
};

export const shouldShowDelivery = (deliveryDate: string) => {
  const SHOW_DELIVERY_THRESHOLD = 7;

  const daysSinceDelivery = differenceInDays(
    new Date(),
    new Date(deliveryDate),
  );

  const shouldShowDelivery = daysSinceDelivery <= SHOW_DELIVERY_THRESHOLD;

  return shouldShowDelivery;
};
